/*
 * Created on Mon Apr 22 2019
 *
 * Copyright (c) 2019 Sébastien Hecart
 */

import i18n from 'i18next'
import fr from './languages/fr'
import { initReactI18next } from 'react-i18next'

//import en from './languages/fr';

// the translations
// (tip move them in a JSON file and import them)
export const languageRessource = {
  fr: { translation: { ...fr } },
  en: { translation: { ...fr } }
}
export const translationGetters = {
  // lazy requires (metro bundler does not support symlinks)
  en: () => require('./languages/fr'),
  fr: () => require('./languages/fr')
}

// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init({
  compatibilityJSON: 'v4',
  resources: languageRessource,
  fallbackLng: 'fr',
  lng: 'fr',
  debug: false,
  keySeparator: '.', // we do not use keys in form messages.welcome
  interpolation: {
    escapeValue: false // react already safes from xss
  }
})

export default i18n
